/* eslint-disable react/no-unused-prop-types */
import { string } from 'prop-types';
import { t } from '@lingui/macro';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import OptionFilter from '../option-filter/OptionFilter';
import getOptionFilterStateServiceFactory from '../option-filter/OptionFilterStateService';

export const filterId = 'InterfacePriority';
export const filterTitle = t`Priority`;
export const options = [
    {
        name: t`High`,
        value: 'high',
    },
    {
        name: t`Low`,
        value: 'low',
    },
];

function InterfacePriorityFilter({ state, filterActions }) {
    return <OptionFilter options={options} state={state} filterActions={filterActions} />;
}

InterfacePriorityFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: string,
};

InterfacePriorityFilter.defaultProps = {
    ...OptionFilter.defaultProps,
    id: filterId,
    title: filterTitle,
};

function transformParam(value) {
    return value === 'high' ? 'true' : 'false';
}

export default Filter({
    filterId,
    filterStateServiceFactory: getOptionFilterStateServiceFactory(filterTitle, options, 'priority', transformParam),
})(InterfacePriorityFilter);
